module.exports = __webpack_public_path__ + "static/media/eu.4aa00c09.webp";